import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
import {
  trainingPhaseOf,
  canRemoveTrainingLinked,
  canAddTrainingLinked,
  isTrainingFieldLocked
} from '@/utils/trainingPhase.js'
import { publicPickScope } from '@/utils/tabPages'

function trainingForm(params) {
  return (
    (params &&
      params.state &&
      params.state.formValues &&
      params.state.formValues.training) ||
    {}
  )
}

function trainingPhase(params) {
  return trainingPhaseOf(trainingForm(params))
}

function canRemoveLinked(params, kind) {
  if (!params || params.pageStatus === 'check') return false
  return canRemoveTrainingLinked(trainingPhase(params), kind)
}

function canAddLinked(params, kind) {
  if (!params || params.pageStatus === 'check') return false
  const phase = trainingPhase(params)
  if (kind === 'paper' && phase === 'C') {
    const form = trainingForm(params)
    const people = form.shouldArrivePeople || []
    const answered = people.some(
      (item) => item && item.assessmentScore != null && item.assessmentScore !== ''
    )
    return !answered
  }
  return canAddTrainingLinked(phase, kind)
}

function fieldLocked(params, key) {
  if (!params || params.pageStatus === 'check') return true
  return isTrainingFieldLocked(trainingPhase(params), key)
}

function isArticleMaterial(params) {
  const row = (params && (params.row || params.currentRow)) || {}
  return row.dataFormat === 'article'
}

function articleFileDetailPage() {
  return {
    buttonName: '关联文件',
    name: (params) => (isArticleMaterial(params) ? 'trainingMaterials' : 'previewMaterials'),
    type: (params) => (isArticleMaterial(params) ? 'stepForm' : 'preview'),
    theme: (params) => (isArticleMaterial(params) ? 'trainingMaterials' : 'preview'),
    step: (params) =>
      isArticleMaterial(params) ? 'trainingMaterialsInfo' : 'previewInfo',
    label: (params) => {
      const row = (params && (params.row || params.currentRow)) || {}
      if (!row.dataName) return '预览或查看文件'
      if (row.dataFormat === 'article') return '查看图文：' + row.dataName
      return (row.dataFormat === 'video' ? '播放：' : '预览：') + row.dataName
    },
    pageStatus: (params) => (isArticleMaterial(params) ? 'check' : undefined),
    checkType: (params) => (isArticleMaterial(params) ? 'checkByUid' : undefined),
    checkFun: (params) =>
      isArticleMaterial(params) ? 'training/getTrainingMaterialsInfo' : undefined,
    previewParams: (params) => {
      const row = (params && (params.row || params.currentRow)) || {}
      if (!row.dataFormat || row.dataFormat === 'article') return null
      return {
        key: 'trainingMaterials',
        uid: row.associatedFiles,
        type: row.dataFormat,
        name: row.dataName
      }
    }
  }
}

function currentStepLabel(params) {
  const label =
    params && params.state && params.state.currentStep && params.state.currentStep.label
  return typeof label === 'string' ? label : ''
}

const addedFlagColumn = {
  prop: 'addedFlag',
  label: '状态',
  width: '80px',
  tag: [{ label: '已添加', type: 'success' }]
}

const training = {
  training: {
    name: 'training',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'stepForm',
      'drawerTable',
      'dialogForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'training/addTraining',
    editFun: 'training/editTraining',
    getListFun: 'training/getTrainingList',
    deleteFun: 'training/deleteTraining',
    detailPage: [
      {
        buttonName: '新增',
        name: 'training',
        type: 'stepForm',
        theme: 'training',
        step: 'trainingInfo',
        label: '新增培训教育任务'
      },
      {
        buttonNames: ['编辑', '查看'],
        name: 'training',
        type: 'stepForm',
        theme: 'training',
        step: 'trainingInfo',
        label: '编辑培训教育任务',
        checkType: 'checkByUid',
        checkFun: 'training/getTrainingInfo'
      },
      {
        buttonName: '选择培训资料',
        name: 'trainingMaterials',
        type: 'drawerTable',
        checkType: 'checkByQuery',
        checkFun: 'training/getTrainingMaterialsList'
      },
      {
        buttonName: '查看培训资料',
        name: 'trainingMaterials',
        type: 'drawerTable',
        pageStatus: 'check'
      },
      {
        buttonName: '选择考核试卷',
        name: 'paper',
        type: 'drawerTable',
        checkType: 'checkByQuery',
        checkFun: 'onlineExam/getPapersList'
      },
      {
        buttonName: '查看考核试卷',
        name: 'paper',
        type: 'drawerTable',
        pageStatus: 'check'
      },
      {
        buttonName: '选择参会人员',
        name: 'arrivePeople',
        type: 'drawerTable',
        checkType: 'checkByQuery',
        query: 'next',
        checkFun: 'contractor/getOrgPersonNames'
      },
      {
        buttonNames: ['执行', '查看参会人员'],
        name: 'signIn',
        type: 'drawerTable',
        checkType: 'checkByUid',
        checkFun: 'signIn/getSignInList'
      }
    ],
    expandColumn: true,
    headButtons: setCheckButtons(['新增' /* , '导入培训计划' */]),
    queryParams: {
      orgUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      trainingType: '',
      trainingMethods: '',
      examineType: '',
      isDone: '',
      query: ''
    },
    selectData: [
      {
        key: 'orgUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true,
        clearable: false,
        span: 8
      },
      {
        key: 'trainingType',
        label: '培训类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.trainingType
        },
        span: 8
      },
      {
        key: 'isDone',
        label: '是否执行',
        type: 'select',
        options: (params) => {
          return params.dictionarys.isFalse
        },
        span: 8
      },
      {
        key: 'trainingMethods',
        label: '培训方式',
        type: 'select',
        options: (params) => {
          return params.dictionarys.trainingMethods
        },
        span: 8
      },
      {
        key: 'examineType',
        label: '考核方式',
        type: 'select',
        options: (params) => {
          return params.dictionarys.examineType
        },
        span: 8
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '培训编号/培训名称',
        span: 8
      }
    ],
    rowData: (params) => {
      return params.state.training.trainingList.result
    },
    rowTotal: (params) => {
      return params.state.training.trainingList.totalSize
    },
    columns: [
      { prop: 'trainingNo', label: '培训编号' },
      {
        prop: 'trainingName',
        label: '培训名称',
        overflow: false,
        width: '240px'
      },
      { prop: 'trainingType', label: '培训类型' },
      {
        prop: 'trainingTimeText',
        label: '培训时间',
        minWidth: '180px',
        overflow: false,
        stack: true
      },
      { prop: 'trainingDuration', label: '培训时长' },
      {
        prop: 'trainingMethods',
        label: '培训方式',
        tag: (params) => {
          return params.dictionarys.trainingMethods
        }
      },
      {
        prop: 'examineType',
        label: '考核方式',
        tag: (params) => {
          return params.dictionarys.examineType
        }
      },
      {
        prop: 'isDone',
        label: '是否执行',
        tag: [
          { label: '未执行', type: 'danger' },
          { label: '未签到', type: 'warning' },
          { label: '已执行', type: 'success' }
        ]
      },
      {
        prop: 'preview',
        label: '培训影像',
        drillDown: true,
        isIdeal: '查看影像',
        width: '100px'
      },
      {
        label: '操作',
        width: '360px',
        buttons: setTableButtons(['查看', '编辑', '删除', '执行', '二维码'])
      }
    ],
    hasPagination: true,
    addArray: true,
    formParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      trainingType: '进场教育',
      trainingNo: (params) => {
        const onboarding = params.state.training.trainingList.result
          ? params.state.training.trainingList.result.filter((item) => {
              return item.trainingType === '进场教育'
            })
          : []
        return (
          'JCJY' +
          (onboarding.length + 1 < 10
            ? '0' + (onboarding.length + 1)
            : onboarding.length + 1)
        )
      },
      trainingName:
        new Date().getFullYear() +
        '年' +
        (new Date().getMonth() + 1) +
        '月进场教育培训',
      trainingTime: '',
      executeTime: '',
      trainingPlace: '',
      trainingDuration: '',
      trainingPerson: '',
      trainingPersons: [],
      trainingMethods: '现场集中培训',
      examineType: '在线考核',
      paper: [],
      paperUid: [],
      paperUids: '',
      paperInfo: [],
      answerRule: '随答随判',
      trainingBrief: '',
      materials: [],
      trainingMaterials: [],
      trainingMaterialsInfo: [],
      trainingMaterial: '',
      shouldArrivePeopleNum: '',
      shouldArrivePeople: [],
      shouldArrivePeoples: '',
      trainingPics: [],
      trainingVideos: [],
      checkInType: 'JYPX',
      fileLists: {
        trainingPics: [],
        trainingVideos: []
      }
    },
    formRules: {
      trainingType: [
        { required: true, message: '请选择培训类型', trigger: 'blur' }
      ],
      trainingNo: [
        { required: true, message: '请输入培训编号', trigger: 'blur' }
      ],
      trainingName: [
        { required: true, message: '请输入培训名称', trigger: 'blur' }
      ],
      trainingTime: [
        { required: true, message: '请选择计划培训时间', trigger: 'blur' }
      ],
      trainingPlace: [
        { required: true, message: '请输入培训地点', trigger: 'blur' }
      ],
      trainingDuration: [
        { required: true, message: '请输入培训时长', trigger: 'blur' }
      ],
      trainingPersons: [
        {
          required: true,
          type: 'array',
          message: '请至少选择或输入一人姓名',
          trigger: 'blur'
        }
      ],
      trainingMethods: [
        { required: true, message: '请选择培训方式', trigger: 'blur' }
      ],
      examineType: [
        { required: true, message: '请选择考核方式', trigger: 'blur' }
      ],
      paperUid: [
        {
          required: (params) => {
            return (
              params.formValues && params.formValues.examineType !== '不予考核'
            )
          },
          type: 'array',
          message: '请选择考核试卷',
          trigger: 'blur'
        }
      ],
      answerRule: [
        {
          required: (params) => {
            return (
              params.formValues && params.formValues.examineType !== '不予考核'
            )
          },
          message: '请选择答题规则',
          trigger: 'blur'
        }
      ],
      trainingMaterials: [
        {
          required: (params) => {
            return (
              params.formValues &&
              params.formValues.trainingMethods === '个人自主学习'
            )
          },
          type: 'array',
          message: '请选择培训材料',
          trigger: 'blur'
        }
      ],
      shouldArrivePeopleNum: [
        { required: true, message: '请输入应到人数', trigger: 'blur' }
      ],
      shouldArrivePeoples: [
        { required: true, message: '请输入应到人员名单', trigger: 'blur' }
      ]
    },
    formData: {
      card: '培训教育任务信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      manualUpload: true,
      fields: [
        {
          key: 'trainingType',
          label: '培训类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.trainingType
          },
          disabled: (params) => fieldLocked(params, 'trainingType')
        },
        {
          key: 'trainingNo',
          label: '培训编号',
          type: 'input',
          disabled: (params) => fieldLocked(params, 'trainingNo')
        },
        {
          key: 'trainingName',
          label: '培训名称',
          type: 'input',
          disabled: (params) => fieldLocked(params, 'trainingName')
        },
        {
          key: 'trainingBrief',
          label: '培训简述',
          type: 'input',
          inputType: 'textarea',
          autosize: { minRows: 2, maxRows: 6 },
          disabled: (params) => fieldLocked(params, 'trainingBrief')
        },
        {
          key: 'trainingTime',
          label: '计划培训时间',
          type: 'time',
          timetype: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          disabled: (params) => fieldLocked(params, 'trainingTime')
        },
        {
          key: (params) => (params.pageStatus !== 'add' ? 'executeTime' : ''),
          label: '执行培训时间',
          type: 'input',
          placeholder: '按首次签到时间自动记录',
          readonly: true
        },
        { key: 'trainingPlace', label: '培训地点', type: 'input', disabled: (params) => fieldLocked(params, 'trainingPlace') },
        {
          key: 'trainingMethods',
          label: '培训方式',
          type: 'select',
          options: (params) => {
            return params.dictionarys.trainingMethods
          },
          disabled: (params) => fieldLocked(params, 'trainingMethods')
        },
        {
          key: 'trainingDuration',
          label: '培训时长',
          type: 'input',
          inputButton: '分钟',
          disabled: (params) => fieldLocked(params, 'trainingDuration')
        },
        {
          key: (params) => {
            return params.pageStatus === 'check'
              ? 'trainingPerson'
              : 'trainingPersons'
          },
          label: '培训人',
          type: 'select',
          options: (params) => {
            return params.state.contractor.managePersonNames
          },
          multiple: true,
          filterable: true,
          create: true,
          placeholder: '请输入培训讲师姓名或选择系统内管理人员,可多选',
          disabled: (params) => fieldLocked(params, 'trainingPersons')
        },
        {
          key: 'trainingMaterialsInfo',
          label: '培训资料',
          type: 'table',
          maxHeight: 320,
          headButtons: (params) => {
            if (params.pageStatus === 'check' || !canAddLinked(params, 'material')) {
              return setCheckButtons(['查看培训资料'])
            }
            return setCheckButtons(['选择培训资料'])
          },
          columns: (params) => {
            const cols = [
              { prop: 'dataName', label: '资料名称' },
              { prop: 'dataFormatName', label: '格式', width: '90px' }
            ]
            if (canRemoveLinked(params, 'material')) {
              cols.push({
                label: '操作',
                width: '90px',
                buttons: setTableButtons([
                  { name: '移除', code: 'removeMaterial' }
                ])
              })
            }
            return cols
          }
        },
        {
          key: 'examineType',
          label: '考核方式',
          type: 'select',
          options: (params) => {
            return params.dictionarys.examineType
          },
          disabled: (params) => fieldLocked(params, 'examineType')
        },
        {
          key: (params) => {
            return params.formValues &&
              params.formValues.examineType !== '不予考核'
              ? 'paperInfo'
              : null
          },
          label: '考核试卷',
          type: 'table',
          maxHeight: 320,
          headButtons: (params) => {
            if (params.pageStatus === 'check' || !canAddLinked(params, 'paper')) {
              return setCheckButtons(['查看考核试卷'])
            }
            return setCheckButtons(['选择考核试卷'])
          },
          columns: (params) => {
            const cols = [
              { prop: 'paperTitle', label: '试卷主题' },
              { prop: 'paperDifficulty', label: '难度', width: '80px' }
            ]
            if (canRemoveLinked(params, 'paper')) {
              cols.push({
                label: '操作',
                width: '90px',
                buttons: setTableButtons([
                  { name: '移除', code: 'removePaper' }
                ])
              })
            }
            return cols
          }
        },
        {
          key: (params) => {
            return params.formValues &&
              params.formValues.examineType !== '不予考核'
              ? 'answerRule'
              : null
          },
          label: '答题规则',
          type: 'select',
          options: (params) => {
            return params.dictionarys.answerRule
          },
          disabled: (params) => fieldLocked(params, 'answerRule')
        },
        {
          key: 'shouldArrivePeopleNum',
          label: '应到人数',
          type: 'input',
          number: true,
          placeholder: '根据应到人员选择自动统计',
          readonly: true
        },
        {
          key: 'shouldArrivePeople',
          label: '应到人员',
          type: 'table',
          maxHeight: 320,
          headButtons: (params) => {
            if (params.pageStatus === 'check' || !canAddLinked(params, 'person')) {
              return setCheckButtons(['查看参会人员'])
            }
            return setCheckButtons(['选择参会人员'])
          },
          columns: (params) => {
            const cols = [
              { prop: 'personName', label: '姓名', width: '90px' },
              { prop: 'phoneNum', label: '手机号码' },
              { prop: 'business', label: '岗位或工种' }
            ]
            if (canRemoveLinked(params, 'person')) {
              cols.push({
                label: '操作',
                width: '90px',
                buttons: setTableButtons([
                  { name: '移除', code: 'removePerson' }
                ])
              })
            }
            return cols
          }
        },
        {
          key: 'trainingPics',
          label: '培训影像（图片）',
          type: 'upload',
          fileType: 'image',
          listType: 'picture-card',
          autoUpload: true,
          accept: 'image/*',
          limit: 4,
          disabled: (params) => fieldLocked(params, 'trainingPics')
        },
        {
          key: 'trainingVideos',
          label: '培训影像（视频）',
          type: 'upload',
          url: '#',
          fileType: 'video',
          listType: 'picture-card',
          autoUpload: false,
          accept: 'video/*',
          limit: 4,
          disabled: (params) => fieldLocked(params, 'trainingVideos')
        }
      ]
    },
    arrivePeople: {
      name: 'arrivePeople',
      title: '请选择应参会机构或人员',
      size: '45%',
      direction: 'rtl',
      getListFun: 'contractor/getOrgPersonNames',
      headButtons: setCheckButtons(['添加应到人员']),
      selectColumn: true,
      outListHeight: 330,
      rowKey: 'personUid',
      defaultSelected: (params) => {
        return trainingForm(params).shouldArrivePeople || []
      },
      queryParams: {
        orgUid: (params) => {
          return params.orgValue
        },
        personType: '管理人员',
        business: '',
        jobTitle: '',
        walkinDate: []
      },
      selectData: (params) => {
        return params.queryValues &&
          params.queryValues.personType === '劳务人员'
          ? [
              {
                key: 'personType',
                label: '人员类型',
                type: 'select',
                options: (params) => {
                  return params.dictionarys.personType
                }
              },
              {
                key: 'orgUid',
                label: '机构名称',
                type: 'select',
                options: (params) => {
                  return params.state.bidSection.unExitLaborCompanys || []
                },
                checkByValue: true,
                clearable: false
              },
              {
                key: 'business',
                label: '工种',
                type: 'select',
                options: (params) => {
                  return params.dictionarys.business || []
                }
              },
              {
                key: 'walkinDate',
                label: '进场时间',
                type: 'time',
                timetype: 'daterange',
                format: 'yyyy-MM-dd'
              }
            ]
          : [
              {
                key: 'personType',
                label: '人员类型',
                type: 'select',
                options: (params) => {
                  return params.dictionarys.personType
                }
              },
              {
                key: 'orgUid',
                label: '机构名称',
                type: 'select',
                options: (params) => {
                  return params.state.bidSection.subBidSection || []
                },
                checkByValue: true,
                clearable: false
              },
              {
                key: 'walkinDate',
                label: '进场时间',
                type: 'time',
                timetype: 'daterange',
                format: 'yyyy-MM-dd'
              }
            ]
      },
      rowData: (params) => {
        const query = params.queryValues ? params.queryValues : {}
        var rowData =
          query.personType === '劳务人员'
            ? params.state.contractor.noExitName || []
            : params.state.contractor.managePersonNames || []
        if (query.business) {
          rowData = rowData.filter((item) => {
            return item.business === query.business
          })
        }
        if (query.walkinDate && query.walkinDate.length === 2) {
          rowData = rowData.filter((item) => {
            if (!item.walkinDate) return false
            return (
              query.walkinDate[0] <= item.walkinDate &&
              item.walkinDate <= query.walkinDate[1]
            )
          })
        }
        return rowData
      },
      columns: (params) => {
        const statusCol = [addedFlagColumn]
        return params.queryValues &&
          params.queryValues.personType === '劳务人员'
          ? statusCol.concat([
              {
                label: '姓名',
                prop: 'personName',
                width: '100px'
              },
              {
                label: '手机号码',
                prop: 'phoneNumber'
              },
              {
                label: '工种',
                prop: 'business'
              },
              {
                label: '进场时间',
                prop: 'walkinDate'
              }
            ])
          : statusCol.concat([
              {
                label: '姓名',
                prop: 'personName',
                width: '100px'
              },
              {
                label: '手机号码',
                prop: 'phoneNumber'
              },
              {
                label: '岗位职务',
                prop: 'jobTitle'
              },
              {
                label: '进场时间',
                prop: 'walkinDate'
              }
            ])
      }
    },
    trainingMaterials: {
      name: 'trainingMaterials',
      title: (params) => {
        return params.pageStatus !== 'check'
          ? '请勾选符合要求培训资料添加'
          : '查看培训资料信息'
      },
      size: '45%',
      direction: 'rtl',
      getListFun: 'training/getTrainingMaterialsList',
      defaultSelected: (params) => {
        return trainingForm(params).trainingMaterialsInfo || []
      },
      headButtons: (params) => {
        return params.pageStatus !== 'check'
          ? setCheckButtons(['添加资料'])
          : null
      },
      selectColumn: (params) => {
        return params.pageStatus !== 'check' ? '30px' : null
      },
      expandColumn: '30px',
      expandAll: true,
      outListHeight: (params) => {
        return params.pageStatus !== 'check' ? 390 : 210
      },
      detailPage: [articleFileDetailPage()],
      queryParams: (params) => {
        return params.pageStatus !== 'check'
          ? {
              orgUid: params.orgValue,
              scope: publicPickScope(
                params.getters && params.getters['user/pages'],
                'trainingMaterials',
                '公共资料库',
                params.userName,
                params.state && params.state.superAdminName
              ),
              dataType: params.state.formValues.training
                ? [params.state.formValues.training.trainingType]
                : [],
              applicableUsers: [],
              dataFormat: '',
              query: '',
              usageCount: null,
              pageviews: null
            }
          : null
      },
      selectData: (params) => {
        return params.pageStatus !== 'check'
          ? [
              {
                key: 'dataType',
                label: '资料类型',
                type: 'select',
                options: params.dictionarys.dataType,
                multiple: true
              },
              {
                key: 'applicableUsers',
                label: '适用对象',
                type: 'select',
                options: params.dictionarys.applicableUsers,
                multiple: true
              },
              {
                key: 'dataFormat',
                label: '资料格式',
                type: 'select',
                options: params.dictionarys.dataFormat,
                checkByValue: true
              },
              {
                key: 'usageCount',
                label: '使用次数',
                type: 'input',
                placeholder: '查询大于等于输入值的数据'
              },
              {
                key: 'pageviews',
                label: '浏览量',
                type: 'input',
                placeholder: '查询大于等于输入值的数据'
              },
              {
                key: 'query',
                label: '关键词',
                type: 'input',
                placeholder: '资料名称/资料标签'
              }
            ]
          : null
      },
      rowData: (params) => {
        return params.pageStatus !== 'check'
          ? params.state.training.trainingMaterials.result
          : params.state.formValues.training
          ? params.state.formValues.training.trainingMaterialsInfo
          : []
      },
      rowTotal: (params) => {
        return params.pageStatus !== 'check'
          ? params.state.training.trainingMaterials.totalSize
          : params.state.formValues.training
          ? params.state.formValues.training.trainingMaterialsInfo.length
          : 0
      },
      columns: [
        addedFlagColumn,
        {
          prop: 'dataFormatName',
          label: '资料格式',
          width: '100px',
          tag: (params) => {
            return params.dictionarys.dataFormat
          }
        },
        {
          prop: 'dataName',
          label: '资料名称',
          align: 'left',
          overflow: false
        },
        {
          prop: 'learningTime',
          label: '学习课时',
          width: '90px'
        }
      ],
      hasPagination: true
    },
    paper: {
      name: 'paper',
      title: (params) => {
        return params.pageStatus !== 'check'
          ? '请勾选符合要求的试卷添加'
          : '查看试卷信息'
      },
      size: '45%',
      direction: 'rtl',
      getListFun: 'onlineExam/getPapersList',
      defaultSelected: (params) => {
        return trainingForm(params).paperInfo || []
      },
      detailPage: [
        {
          buttonName: '试题信息',
          name: 'paperQuestion',
          type: 'tables',
          theme: 'training',
          step: 'paperQuestionList',
          label: '查看试题信息',
          checkType: 'checkByUid',
          checkFun: 'onlineExam/getPaperInfo',
          pageStatus: 'check'
        }
      ],
      headButtons: (params) => {
        return params.pageStatus !== 'check'
          ? setCheckButtons(['添加试卷'])
          : null
      },
      outListHeight: (params) => {
        return params.pageStatus !== 'check' ? 330 : 210
      },
      queryParams: (params) => {
        return params.pageStatus !== 'check'
          ? {
              orgUid: params.orgValue,
              scope: publicPickScope(
                params.getters && params.getters['user/pages'],
                'onlineExam',
                '公共试卷库',
                params.userName,
                params.state && params.state.superAdminName
              ),
              paperType: params.state.formValues.training
                ? [params.state.formValues.training.trainingType]
                : [],
              applicableUsers: [],
              paperStatus: '',
              paperDifficulty: '',
              query: ''
            }
          : null
      },
      selectData: (params) => {
        return params.pageStatus !== 'check'
          ? [
              {
                key: 'paperType',
                label: '试卷类型',
                type: 'select',
                options: params.dictionarys.paperType,
                multiple: true
              },
              {
                key: 'applicableUsers',
                label: '适用对象',
                type: 'select',
                options: params.dictionarys.applicableUsers,
                multiple: true
              },
              {
                key: 'questionType',
                label: '包含题型',
                type: 'select',
                options: params.dictionarys.questionType,
                multiple: true
              },
              {
                key: 'paperDifficulty',
                label: '试卷难度',
                type: 'select',
                options: params.dictionarys.difficulty
              },
              {
                key: 'query',
                label: '关键词',
                type: 'input',
                placeholder: '试卷主题/考点标签'
              }
            ]
          : null
      },
      selectColumn: (params) => {
        return params.pageStatus !== 'check' ? '30px' : null
      },
      expandColumn: '30px',
      expandAll: true,
      rowData: (params) => {
        return params.pageStatus !== 'check'
          ? params.state.onlineExam.papersList.result
          : params.state.formValues.training
          ? params.state.formValues.training.paperInfo
          : []
      },
      rowTotal: (params) => {
        return params.pageStatus !== 'check'
          ? params.state.onlineExam.papersList.totalSize
          : params.state.formValues.training
          ? params.state.formValues.training.paperInfo.length
          : 0
      },
      columns: [
        addedFlagColumn,
        {
          label: '试卷难度',
          prop: 'paperDifficulty',
          tag: (params) => {
            return params.dictionarys.difficulty
          },
          width: '100px'
        },
        {
          label: '试卷主题',
          prop: 'paperTitle',
          align: 'left',
          overflow: false
        },
        {
          label: '试卷总分',
          prop: 'paperTotalScore',
          width: '100px'
        }
      ],
      hasPagination: true
    },
    signIn: {
      name: 'signIn',
      title: '教育培训签到及考核详情',
      size: '50%',
      direction: 'rtl',
      getListFun: 'signIn/getSignInList',
      getParentFun: 'training/getTrainingList',
      deleteFun: 'signIn/deleteSignIn',
      detailPage: [
        {
          buttonName: '添加签到',
          name: 'addSign',
          type: 'dialogForm'
        },
        {
          buttonName: '考卷',
          name: 'paperQuestion',
          type: 'tables',
          theme: 'training',
          step: 'paperQuestionList',
          label: (params) => {
            return (
              (params.currentRow ? params.currentRow.personName : '考核') +
              '答卷详情'
            )
          },
          checkType: 'checkByKey',
          checkKey: 'paperUid',
          checkFun: 'onlineExam/getPaperInfo',
          pageStatus: (params) => {
            return params.currentRow &&
              params.currentRow.isQualified === '需人工判分'
              ? 'edit'
              : 'check'
          }
        }
      ],
      headButtons: setCheckButtons(['批量签到', '添加签到']),
      selectColumn: true,
      outListHeight: 240,
      rowData: (params) => {
        return params.state.signIn.signInList
      },
      columns: (params) => {
        var columns = [
          {
            label: '姓名',
            prop: 'personName',
            width: '90px'
          },
          {
            label: '手机号码',
            prop: 'phoneNum'
          },
          {
            label: '岗位或工种',
            prop: 'business'
          },
          {
            label: '是否签到',
            prop: 'isSignIn',
            switch: 'isCheckedIn',
            width: '110px'
          }
        ]
        if (
          params.state.currentRow.training &&
          params.state.currentRow.training.examineType !== '不予考核'
        ) {
          columns.push(
            {
              label: '考核成绩',
              prop: 'assessmentScore',
              width: '80px'
            },
            {
              label: '是否合格',
              prop: 'isQualified',
              tag: [
                { label: '考试不合格', type: 'danger' },
                { label: '考试合格', type: 'success' },
                { label: '需人工判分', type: 'warning' }
              ]
            },
            {
              label: '操作',
              width: '140px',
              buttons: setTableButtons(['考卷', '删除'])
            }
          )
        } else {
          columns.push({
            label: '操作',
            buttons: setTableButtons(['删除'])
          })
        }
        return columns
      }
    },
    addSign: {
      name: 'addSign',
      title: '添加临时参会人员',
      addFun: 'signIn/addSignIn',
      getParentFun: 'signIn/getSignInList',
      addArray: true,
      formParams: {
        personName: '',
        phoneNum: '',
        business: '',
        isCheckedIn: '已签到',
        checkInEventUid: (params) => params.state.currentRow.training.uid,
        checkInType: 'JYPX',
        partType: '临时',
        checkInTime: (params) => params.state.currentRow.training.trainingTime
      },
      formRules: {
        personName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phoneNum: [
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '手机号码输入不合法',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        { key: 'personName', label: '姓名', type: 'input', span: 18 },
        { key: 'phoneNum', label: '手机号码', type: 'input', span: 18 },
        { key: 'business', label: '岗位或工种', type: 'input', span: 18 }
      ]
    }
  },
  paperQuestion: {
    name: 'paperQuestion',
    componentTypes: ['navigate', 'check', 'tables'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'onlineExam/getPaperInfo',
    headButtons: (params) => {
      return params.pageStatus === 'edit'
        ? setCheckButtons(['更新', '提交'])
        : null
    },
    tagInfo: (params) => {
      const paperInfo =
        (params.state.onlineExam && params.state.onlineExam.paperInfo) || {}
      const assessment =
        (params.state.currentRow && params.state.currentRow.signIn) || {}
      const isAnswerDetail = currentStepLabel(params).slice(-4) === '答卷详情'
      return (
        '当前试卷共计\xa0\xa0' +
        (paperInfo.questionNum || 0) +
        '\xa0\xa0道题，满分\xa0\xa0' +
        (paperInfo.totalScore || 0) +
        '\xa0\xa0分' +
        (isAnswerDetail
          ? '，本次考试得分\xa0\xa0' +
            (assessment.assessmentScore || 0) +
            '\xa0\xa0分，' +
            (assessment.isQualified || '') +
            '。'
          : '。')
      )
    },
    outListHeight: (params) => {
      return params.pageStatus === 'edit' ? 270 : 300
    },
    expandColumn: true,
    expandAll: true,
    radios: (params) => {
      const questionType =
        (params.state.onlineExam &&
          params.state.onlineExam.paperInfo &&
          params.state.onlineExam.paperInfo.questionTypesIncluded) ||
        []
      var radios = ['全部'].concat(questionType)
      return params.pageStatus === 'edit' ? null : radios
    },
    rowData: (params) => {
      return params.getters['onlineExam/questionList']
    },
    columns: (params) => {
      var columns = [
        {
          label: '序号',
          prop: 'questionCode',
          width: '60px'
        },
        {
          label: '题目类型',
          prop: 'questionType',
          width: '90px',
          tag: (params) => {
            return params.dictionarys.questionType
          }
        },
        {
          label: '题目分值',
          prop: 'questionScore',
          width: '90px'
        },
        {
          label: '题目内容',
          prop: 'content',
          align: 'left',
          overflow: false
        }
      ]
      if (currentStepLabel(params).slice(-4) === '答卷详情') {
        columns.push({
          label: '得分',
          prop: 'answerScore',
          width: '120px',
          formItem: (params) => {
            return params.pageStatus === 'edit'
              ? {
                  type: 'input'
                }
              : null
          },
          number: 0
        })
      }
      return columns
    },
    hasPagination: true
  }
}

export default training
